import { Component } from 'react';

import { VoidInterface } from 'types/functions';
import { translate } from 'utils/translate';

import Comment from './Comment';
import Icon from './Icon';
import Input from './Input';

interface ManualUpdateValueProps {
    label: string;
    unit: string;

    decimal: number;
    value: number[];
    range: number[];
    close: VoidInterface;
    save: (updatedValue: number[]) => void;
}

interface ManualUpdateValueState {
    value: any[];
    range: number[];
    minError: string;
    maxError: string;
}

class ManualUpdateValue extends Component<ManualUpdateValueProps, ManualUpdateValueState> {
    constructor(props: ManualUpdateValueProps) {
        super(props);
        this.state = {
            value: props.value || [0, 0],
            range: props.range || [0, 0],
            minError: '',
            maxError: '',
        };
    }

    handelChange = (name: string, value: string) => {
        let re: RegExp | null = null;

        if (this.props.decimal === 2) {
            re = /^(\d+)(\.)?(\d{0,2})?$/; // Allows optional decimal and up to 2 digits after
        } else if (this.props.decimal === 1) {
            re = /^(\d+)(\.)?(\d{0,1})?$/; // Allows optional decimal and up to 1 digit after
        } else {
            re = /^[0-9\b]+$/; // Only numbers, no decimal
        }

        if (value !== '' && !re.test(value)) {
            return false;
        }

        // If last character is a dot, don't parseFloat
        let newValue: number | string = value.endsWith('.') ? value : parseFloat(value);

        // 🔥 NEW LOGIC: if parsed value is NaN → fallback to previous min/max
        if (typeof newValue === 'number' && isNaN(newValue)) {
            newValue = '';
        }

        if (name === 'min') {
            this.setState({ value: [newValue, this.state.value[1]] }, () => {
                this.validate(name);
            });
        } else {
            this.setState({ value: [this.state.value[0], newValue] }, () => {
                this.validate(name);
            });
        }
    };

    validate = (name: string) => {
        const rangeMin = this.props.range[0];
        const rangeMax = this.props.range[1];
        const valueMin = this.state.value[0];
        const valueMax = this.state.value[1];
        let error = '';
        const currentValue = name === 'min' ? this.state.value[0] : this.state.value[1];
        if (currentValue < rangeMin || currentValue > rangeMax) {
            error = `${name} must be between ${rangeMin}:${rangeMax}`;
        } else if (name === 'valueMax' && currentValue < valueMin) {
            error = `${name} must be greater than ${valueMin}`;
        } else if (name === 'valueMin' && currentValue > valueMax) {
            error = `${name} must be less than ${valueMax}`;
        }
        if (name === 'min') {
            this.setState({ minError: error });
        } else {
            this.setState({ maxError: error });
        }
    };

    save = () => {
        if (this.state.minError || this.state.maxError) {
            return;
        }

        this.props.save(this.state.value);

        this.props.close();
    };

    render() {
        const { label, unit } = this.props;

        return (
            <div className="w-full  col-span-12">
                <div className="mb-2 capitalize">
                    {label} ({unit})
                </div>
                <div className="flex justify-between">
                    <div className="relative ">
                        <div className="flex font-medium leading-5 text-gray-700">
                            <div>
                                {translate('from')}
                                <Input
                                    onChange={this.handelChange}
                                    name="min"
                                    placeholder={translate('Min value')}
                                    value={this.state.value[0]}
                                    className="w-10 px-1 mx-1 h-6  "
                                />
                                {translate('to')}
                                <Input
                                    onChange={this.handelChange}
                                    name="max"
                                    placeholder={translate('Max value')}
                                    value={this.state.value[1]}
                                    className="w-10 px-1 mx-1 h-6  "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="pt-2 flex flex-row-reverse justify-between">
                        <div className="flex -mt-2">
                            <div onClick={this.props.close}>
                                <Icon className="cursor-pointer float-right mr-1 text-gray-700 h-5 w-5">
                                    <path d="M18 6l-12 12"></path>
                                    <path d="M6 6l12 12"></path>
                                </Icon>
                            </div>

                            <div onClick={this.save}>
                                <Icon className="cursor-pointer float-right mr-1 text-gray-700 h-5 w-5">
                                    <path d="M5 12l5 5l10 -10"></path>
                                </Icon>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.minError || this.state.maxError ? (
                    <Comment type="error">
                        {this.state.maxError && this.state.minError
                            ? `${this.state.minError} / ${this.state.maxError}`
                            : `${this.state.minError} ${this.state.maxError}`}
                    </Comment>
                ) : null}
            </div>
        );
    }
}

export default ManualUpdateValue;
